var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "w-full px-5 py-6 border-1 border-solid border-grey-200 rounded-lg bg-white"
    },
    [
      _c("p", { staticClass: "u-body text-heading font-bold mb-2" }, [
        _vm._v("Unsure?")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "u-body mb-4" }, [
        _vm._v(
          "\n    Enter a postcode to find your nearest " +
            _vm._s(_vm.postcodeSearchType) +
            ":\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-7" },
        [
          _c("NearbyInput", {
            attrs: {
              type: _vm.type,
              placeholder: "eg: 3205",
              communities: _vm.communities,
              nearbyRedirectUrl: _vm.nearbyRedirectUrl
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.navItems.length
        ? _c(
            "ul",
            _vm._l(_vm.navItems, function(navItem, index) {
              return _c(
                "li",
                {
                  key: navItem.id,
                  class: {
                    "mt-2": index !== 0
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: [
                        "group relative focus:outline-none ",
                        navItem.headerNavType
                          ? "inline-flex flex-nowrap text-heading font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out"
                          : "inline-block text-body u-body-lg",
                        navItem.classes,
                        {
                          "cursor-default": !navItem.url
                        }
                      ],
                      attrs: {
                        href: navItem.url,
                        target: navItem.newWindow ? "_blank" : "_self"
                      }
                    },
                    [
                      _c("span", {
                        class: [
                          "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: [
                            "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                          ]
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(navItem.title) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }